@if (messageToShow$ | async; as message) {
<faxe-notification-message
  [message]="message"
  [cssClasses]="presentationState.toLowerCase()"
  (removeMessage)="onRemoveMessage()"
  (renderedHeight)="onRenderedHeight($event)"
>
</faxe-notification-message>
}
